
    <fieldmagic-pagination-links
      [hideRefresh]="true"
      [topOnly]="true"
    >
      <table class="table table-bordered">
        <thead>
          <tr>
            <td width="20%">
              <fieldmagic-text
                content="Asset"
                purpose="table-header"
              >
              </fieldmagic-text>
            </td>
            <td width="10%">
              <fieldmagic-text
                content="Status"
                purpose="table-header"
              >
              </fieldmagic-text>
            </td>
            <td width="5%"></td>
          </tr>
        </thead>
        <tbody *ngIf="list$ | async as assets">
          <tr
            *ngIf="assets | blank"
          >
            <td
              class="text-center"
              colspan="3"
            >
              No linked assets.
            </td>
          </tr>

          <tr
            *ngFor="let asset of assets; let asset_index = index"
            [class.row-asset-pending]="asset.inspection_status == 'awaiting_completion'"
            [class.row-asset-passed]="asset.inspection_status == 'pass'"
            [class.row-asset-failed]="asset.inspection_status == 'fail'"
          >
            <td>
              <a
                [routerLink]="['/assets', asset.id]"
                target="_blank"
                matTooltip="Click to view asset"
              >
                {{ asset.text }}
              </a>
            </td>

            <td>
              {{ asset.inspection_status | translate }}
            </td>

            <td>
              <div class="w-100 d-flex justify-content-center">
                <checklist-render-prompts-button
                  [options]="{
                    job_id: asset.job_id,
                    asset_id: asset.id,
                    asset_type_id: asset.asset_type_id,
                    module_name: 'jobs',
                    questions_name: 'per_asset_prompts',
                    asset_job_id: asset.asset_job_id,
                    asset_type_variant_id: asset.asset_type_variant_id
                  }"
                  (complete)="onComplete($event, asset_index)"
                >
                </checklist-render-prompts-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldmagic-pagination-links>
  